import { createRoute } from '@tanstack/react-router';
import { IconCalendar, IconMail } from '@tabler/icons-react';
import type { Zone } from '@hana/shell';
import { registerBoxFixtures } from './data';
import { BoxPage } from './mail/BoxPage';
import { CalendarPage } from './calendar/CalendarPage';
import { AskHanaPage } from './askhana/AskHanaPage';

export { AskHanaPage };
export { setBoxGraph, type BoxGraph } from './data';

// Vùng HANA Box (/box): hộp thư chung nhóm BKG (luồng I, docs/streams/I.md). Khung + dữ liệu mẫu; màn thư Mint-Box ở mail/BoxPage (I-02a).

export const zone: Zone = {
  key: 'box',
  name: 'HANA Box',
  fixtures: registerBoxFixtures,
  top: [{ key: 'home', label: 'Thư', to: '/box', icon: IconMail }, { key: 'calendar', label: 'Lịch', to: '/box/calendar', icon: IconCalendar }],
  nav: [],
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/', component: BoxPage }),
    createRoute({ getParentRoute: () => parent, path: '/calendar', component: CalendarPage }),
    // Ask HANA (I-05): màn toàn trang, gắn tạm ở /box/ask để đo; A lắp vào shell (nút cú ở mọi vùng) theo issue luong-a.
    createRoute({ getParentRoute: () => parent, path: '/ask', component: AskHanaPage }),
  ],
};
